<script>
    import { metaInfo } from "@/core/MetaInfo";
    import HomeHero from "@finamill/components/HomeHero.vue";
    import HomeAbout from "@finamill/components/HomeAbout.vue";
    import HomePartners from "@finamill/components/HomePartners.vue";

    export default {
        name: "Home",
        components: { HomeHero, HomeAbout, HomePartners },
        metaInfo() {
            return metaInfo.getMeta("home");
        },
    };
</script>

<template>
    <div class="home-page">
        <home-hero />
        <home-about />
        <home-partners />
    </div>
</template>

<style lang="scss">
    .home-page {
        overflow: hidden;
    }
</style>
